import { render, staticRenderFns } from "./MealLabelLarge.vue?vue&type=template&id=1ed65e3c&"
import script from "./MealLabelLarge.vue?vue&type=script&lang=js&"
export * from "./MealLabelLarge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports